import { isBefore, isEqual } from 'date-fns';
import { Session } from './session.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class SessionList {
  public set sessions(sessions: Session[]) {
    this._sessions = sessions;
  }

  public get sessions(): Session[] {
    return this.sortSessions(this._sessions);
  }

  private _sessions: Session[];

  constructor(sessions: Session[]) {
    this._sessions = this.sortSessions(sessions);
  }

  public static fromDto(dto: any): SessionList {
    const sessions: Session[] =
      dto.sessions?.map((sessionDto: any) => Session.fromDto(sessionDto)) ?? [];
    return new SessionList(sessions);
  }

  private sortSessions(sessions: Session[]): Session[] {
    this.filterSessionsAlphabetically(sessions);
    this.filterByDate(sessions, 'startedAt');
    this.filterByDate(sessions, 'lastVisitedAt');
    this.filterSessionsByDateFinished(sessions);
    return sessions;
  }

  /**
   * Filter the sessions alphabetically.
   */
  private filterSessionsAlphabetically(sessions: Session[]): void {
    sessions.sort((a, b) => {
      return a.questionnaire.title.localeCompare(b.questionnaire.title);
    });
  }

  /**
   * Filter the sessions by the date.
   */
  private filterByDate(
    sessions: Session[],
    property: 'startedAt' | 'lastVisitedAt',
  ): void {
    sessions.sort((a, b) => {
      if (!a[property]) {
        return 1;
      }

      if (!b[property]) {
        return -1;
      }

      if (isEqual(a[property] as Date, b[property] as Date)) {
        return 0;
      }

      return isBefore(a[property] as Date, b[property] as Date) ? 1 : -1;
    });
  }

  /**
   * Filter the sessions by the date at which they are finished. The session
   * that is finished the last will be at the top. Sessions that are not yet
   * finished are left at the position they are at initially.
   */
  private filterSessionsByDateFinished(sessions: Session[]): void {
    sessions.sort((a, b) => {
      if (!a.finishedAt && b.finishedAt) {
        return -1;
      }

      if (!b.finishedAt && a.finishedAt) {
        return 1;
      }

      return 0;
    });
  }
}
